// Others
import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import { IProfile } from '~/utils/interface/user';
import { urlApiUser } from '~/utils/constants/apis';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const userApi = {
  getProfile() {
    const url = urlApiUser.getProfile;
    return axiosClient.get<IBaseResponse<IProfile>>(url);
  },

  updateProfile(formData: FormData) {
    const url = urlApiUser.updateProfile;
    return axiosClient.put<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  changePassword(body: { currentPassword: string; newPassword: string }) {
    const url = urlApiUser.changePassword;
    return axiosClient.put<IBaseResponse>(url, body);
  },
};

export default userApi;
